//commented code for future use
export const invoiceColumnsGroup:any={
    expenses:{
        expensesSupplierGroup:[12,1,2,6,136,137,15,17,27,32,33,34,35
            // {id:12,column_name:'branch'},
            // {id:1,column_name:'voucher_invoice_date'},
            // {id:2,column_name:'voucher_invoice_number'},
            // {id:6,column_name:'supplier_name'},
            // {id:8,column_name:'supplier_address'},
            // {id:15,column_name:'nature_of_expense'},
            // {id:17,column_name:'description_as_per_bill'},
            // {id:27,column_name:'total_value'},
            // {id:32,column_name:'net_payment_made'},
            // {id:33,column_name:'mode_of_payment'},
            // {id:34,column_name:'dop_in_bank_cash'},
            // {id:35,column_name:'narration_in_bank_statement'},
        ],
        expensesGstGroup:[102,22,23,24,25,26
            // {id:102,column_name:'place_of_supply'},
            // {id:22,column_name:'taxable_value'},
            // {id:23,column_name:'gst_percentage'},
            // {id:24,column_name:'igst_amount'},
            // {id:25,column_name:'sgst_amount'},
            // {id:26,column_name:'cgst_amount'},
        ],
        expensesShippingGroup:[124,125,126
            // {id:124,column_name:'ship_to_name'},
            // {id:125,column_name:'ship_to_address'},
            // {id:126,column_name:'ship_to_gst'},
        ],
        expensesSkucodeGroup:[119,19,20,108
            // {id:119,column_name:'sku_code'},
            // {id:19,column_name:'unit'},
            // {id:20,column_name:'quantity'},
            // {id:108,column_name:'rate'},
        ],
        expensesAmountGroup:[121,30
            // {id:121,column_name:'amount'},
            // {id:30,column_name:'discount'},
        ],
    },
    revenues:{
        revenuesSupplierGroup:[37,130,131,40,41,46,138,139,55,57,84,86,87,89,91
            // {id:37,column_name:'bill_from'},
            // {id:38,column_name:'address'},
            // {id:40,column_name:'voucher_invoice_date'},
            // {id:41,column_name:'voucher_invoice_number'},
            // {id:46,column_name:'customer_name'},
            // {id:48,column_name:'customer_address'},
            // {id:55,column_name:'nature_of_income'},
            // {id:57,column_name:'description_as_per_bill'},
            // {id:84,column_name:'total_value'},
            // {id:86,column_name:'net_amount_received'},
            // {id:87,column_name:'mode_of_receipts'},
            // {id:89,column_name:'dor_in_bank_cash'},
            // {id:91,column_name:'narration_in_bank_statement'},
        ],
        revenuesGstGroup:[50,65,66,67,68,69
            // {id:50,column_name:'place_of_supply'},
            // {id:65,column_name:'taxable_value'},
            // {id:66,column_name:'gst_percentage'},
            // {id:67,column_name:'igst_amount'},
            // {id:68,column_name:'sgst_amount'},
            // {id:69,column_name:'cgst_amount'},
        ],
        revenuesShippingGroup:[127,128,129
            // {id:127,column_name:'ship_to_name'},
            // {id:128,column_name:'ship_to_address'},
            // {id:129,column_name:'ship_to_gst'},
        ],
        revenuesSkucodeGroup:[120,59,60,116
            // {id:120,column_name:'sku_code'},
            // {id:59,column_name:'unit'},
            // {id:60,column_name:'quantity'},
            // {id:116,column_name:'rate'},
        ],
        revenuesAmountGroup:[80,78
            // {id:80,column_name:'amount'},
            // {id:78,column_name:'discount'},
        ],
    },
}
